import { Component } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'demo-upp-dropdown',
    templateUrl: './demo-upp-dropdown.html',
    styleUrls: ['../demo-common.scss', './demo-upp-dropdown.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppDropdownComponent {
    actionsOpen = false;
    sortOpen = false;

    toggleActions() {
        this.actionsOpen = !this.actionsOpen;
    }

    onActionsClosed() {
        this.actionsOpen = false;
    }

    toggleSort() {
        this.sortOpen = !this.sortOpen;
    }

    onSortClosed() {
        this.sortOpen = false;
    }
}
